import { c as _c } from "react-compiler-runtime";
import { useEffect } from 'react';
import { normalizeTypeId, SOCIAL_BROADCAST_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { CommentObjectType } from '../constants';
import { setTourStepContentOverrides } from 'onboarding-tours/util/tourStorage';
import { COMMENT_ONBOARDING_TOUR_ID } from '../constants/tourIDs';
import I18n from 'I18n';
export default function useOverrideTourContent(t0) {
  "use memo";

  const $ = _c(3);
  const {
    objectType
  } = t0;
  let t1;
  let t2;
  if ($[0] !== objectType) {
    t1 = () => {
      let tourTextOverrideKey = "default";
      const isSocialBroadcast = Boolean(objectType && normalizeTypeId(objectType) === SOCIAL_BROADCAST_TYPE_ID);
      if (isSocialBroadcast) {
        tourTextOverrideKey = "text-social";
      }
      if (isSocialBroadcast || objectType === CommentObjectType.COMMENTING_SANDBOX) {
        setTourStepContentOverrides({
          tourId: COMMENT_ONBOARDING_TOUR_ID,
          stepId: "step 1",
          overrides: {
            textOptions: {
              text: I18n.text(`collaborationSidebar.commentOnboardingText.${tourTextOverrideKey}`)
            }
          }
        });
      }
    };
    t2 = [objectType];
    $[0] = objectType;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
}